module.exports = "/_next/static/images/main-visual-menu-cooking@2x-8a2da98b914301e2c9dec232a2c5c267.jpg";